<div class="action-panel"
     style="position: absolute; bottom: 50px; left: 0; width: 100%;overflow: hidden; z-index: 99;" [ngClass] = "{'dynamic-panel-height': panelHeight === 'full'}" >
  <div class="action-header"style="display:flex; justify-content: space-between; align-items: center; height: 50px;">
    <div style="padding: 0 15px;">
      <ng-content select="[action-title]"></ng-content>
    </div>
    <div style="cursor: pointer;" matTooltip="Close" (click)="clear()">
      <div class="fal fa-times" style="padding: 0 15px; font-size: 16px;"></div>
    </div>
  </div>
  <ng-content select="[action-body]" class="action-body"></ng-content>
  <div *ngIf="includeFooter" style="position: absolute; bottom: 0; padding: 12px; width: calc(100% - 24px); border-top: solid 1px rgba(91, 91, 91, 0.32);">
    <ng-content select="[action-footer]"></ng-content>
  </div>
</div>
